/* eslint-disable @typescript-eslint/no-explicit-any */ export var StatFlags;
(function(StatFlags) {
    StatFlags[StatFlags["None"] = 0] = "None";
    StatFlags[StatFlags[// NOTE: userId will be removed from payload,
    // anonymousId will be replaced with a new random one
    "Anonymous"] = 1] = "Anonymous";
    StatFlags[StatFlags[// NOTE: both session flags are ignored by _trackBatch_
    "OnceInSession"] = 2] = "OnceInSession";
    StatFlags[StatFlags["OnlyFirstSession"] = 4] = "OnlyFirstSession";
    StatFlags[StatFlags[// NOTE: event won't be sent if worker is not available
    "OnlyForWorker"] = 8] = "OnlyForWorker";
    StatFlags[StatFlags[// NOTE: send event immediately without pushing it to a batch queue
    "SendImmediately"] = 16] = "SendImmediately";
    StatFlags[StatFlags[// NOTE: don't add common params to the event/events
    "NoCommonParams"] = 32] = "NoCommonParams";
})(StatFlags || (StatFlags = {}));
